import dropdownElementTemplate from './dropdownElement.html';
import dropdownTemplate from './dropdownTemplate.html';

const dropdown = {
  bindings: {
    title: '@',
    selection: '='
  },
  template: dropdownElementTemplate,
  controller: function($scope, $ionicPopover, ApiPicklist) {
    this.popover = $ionicPopover.fromTemplate(dropdownTemplate, { scope: $scope });

    this.$onInit = () => {
      var ctrl = this;
      ApiPicklist.retrieveLevelsOfInterest().then((levelsOfInterest) => {
        ctrl.options = levelsOfInterest.data;
      });
    };

    this.openPopover = ($event) => {
      this.popover.show($event);
    };

    this.closePopover = (option) => {
      this.selection = option.key;
      this.selectedOption = option;
      this.popover.hide();
    };

    //Cleanup the popover when we're done with it!
    $scope.$on('$destroy', () => {
      this.popover.remove();
    });
  }
};

export default dropdown;



/** WEBPACK FOOTER **
 ** ./src/app/directives/popovers/dropdown.js
 **/